<template>
  <b-container class="self-assesment">
    <b-button
      v-if="showReturn"
      variant="primary"
      style="cursor: pointer; margin-top: 15px"
      @click="goToList"
    >
      {{ $t("label_administration_goBack") }}
    </b-button>
    <b-row>
      <b-col v-if="tableData" class="formGeneric">
        <template v-if="editMode">
          <h2 style="margin: 25px">
            {{ $t(titleLabel ||  ("label_administration_" + tableData.name + "_displayName")) }}
          </h2>
          <div style="margin: 25px 0px">
            {{ $t(descriptionLabel || ("label_administration_" + tableData.name + "_description")) }}
          </div>
        </template>


        <template v-if="!editMode">
          <h2 style="margin: 25px">
            {{ $t(tableData.listTitleLabel || ("label_administration_" + tableData.name + "_displayName")) }}
          </h2>
          <div style="margin: 25px 0px">
            {{ $t(tableData.listDescriptionLabel ||("label_administration_" + tableData.name + "_description")) }}
          </div>
        </template>

        <b-form @submit.prevent="">
          <template v-if="groupByCategory">
            <b-form-group
              v-for="(category, categoryIndex) in tableData.fieldCategories"
              :key="categoryIndex"
              horizontal
              breakpoint="lg"
              :label="$t(category)"
              label-size="lg"
              label-class="title"
              label-cols-md="3"
            >
              <b-form-group
                v-for="(field, index) in getFieldsByCategory(
                  tableData.fields,
                  category
                )"
                :id="'label_' + field.name"
                :key="index"
                horizontal
                label-class="text-sm-right"
                label-cols="3"
                :label="$t(labelPrefix + field.name)"
                :label-for="field.name"
              >
                <div v-if="!editMode">
                  {{ field.value }}
                </div>
                <template v-if="editMode">
                  <b-form-select
                    v-if="
                      field.type == FieldType.SELECT ||
                      field.type == FieldType.SELECT_LIST
                    "
                    :id="field.name"
                    v-model="field.value"
                    :options="field.selectOptions"
                    size="sm"
                    class="mt-3 form-control"
                    @blur="checkValidations(field)"
                    @change="saveOnKeyUp(field.name, field.value)"
                  />

                  <b-form-input
                    v-if="field.type == FieldType.INPUT"
                    :id="field.name"
                    v-model="field.value"
                    :class="{
                      'input-error':
                        errors[field.name] && errors[field.name].length,
                    }"
                    type="text"
                    @input="saveOnKeyUp(field.name, field.value)"
                    @blur="checkValidations(field)"
                  />

                  <template v-if="field.type == FieldType.CHECKBOX">
                    <div
                      v-for="(option, optionIndex) in field.selectOptions"
                      :key="optionIndex"
                    >
                      <b-form-checkbox
                        :id="option.field"
                        v-model="option.value"
                        type="text"
                        @change="saveOnKeyUp(option.field, option.value)"
                        @blur="checkValidations(field)"
                      >
                        {{ $t(option.label) }}
                      </b-form-checkbox>
                    </div>
                  </template>
                </template>
                <form-error
                  :errors="errors[field.name]"
                  :field-name="field.name"
                />
              </b-form-group>
            </b-form-group>
          </template>
          <b-form-group
            v-if="!groupByCategory"
            horizontal
            breakpoint="lg"
            label-size="lg"
            label-class="break-label"
          >
            <b-form-group
              v-for="(field, index) in tableData.fields"
              :id="'label_' + field.name"
              :key="index"
              horizontal
              label-class="text-sm-right"
              label-cols="3"
              :label="$t(labelPrefix + field.name)"
              :label-for="field.name"
            >
              <div
                v-if="
                  !editMode &&
                  field.type !== FieldType.SELECT &&
                  field.type !== FieldType.SELECT_LIST
                "
              >
                <span v-if="field.isSecret">******</span>
                <span v-if="!field.isSecret">{{ field.value | formatDate }}</span>
              </div>
              <div
                v-if="
                  !editMode &&
                  (field.type === FieldType.SELECT ||
                    field.type === FieldType.SELECT_LIST)
                "
              >
                {{ getValueFromList(field.value, field.selectOptions) }}
              </div>
              <template v-if="editMode && field.isSecret && idToEdit"><b-button v-if="idToEdit" @click="showResetPasswordModal=true">Reset Password</b-button></template>
              <template v-if="editMode && (!field.isSecret || !idToEdit)">
                <b-form-select
                  v-if="
                    field.type == FieldType.SELECT ||
                    field.type == FieldType.SELECT_LIST
                  "
                  :id="field.name"
                  v-model="field.value"
                  :options="field.selectOptions"
                  size="sm"
                  class="mt-3 form-control"
                  @blur="checkValidations(field)"
                  @change="saveOnKeyUp(field.name, field.value)"
                />

                <b-form-input
                  v-if="field.type == FieldType.INPUT"
                  :id="field.name"
                  v-model="field.value"
                  :class="{
                    'input-error':
                      errors[field.name] && errors[field.name].length,
                  }"
                  type="text"
                  @input="saveOnKeyUp(field.name, field.value)"
                  @blur="checkValidations(field)"
                />

                <b-form-datepicker
                  v-if="field.type == FieldType.DATE_PICKER"
                  :id="field.name"
                  v-model="field.value"
                  :state="errors[field.name] && errors[field.name].length"
                  @context="
                    saveOnKeyUp(field.name, field.value, true);
                    checkValidations(field);
                  "
                />
                <b-form-checkbox
                  v-if="field.type == FieldType.BOOLEAN"
                  :id="field.name"
                  v-model="field.value"
                  :class="{
                    'input-error':
                      errors[field.name] && errors[field.name].length,
                  }"
                  type="text"
                  @input="saveOnKeyUp(field.name, field.value)"
                />
              </template>
              <form-error
                :errors="errors[field.name]"
                :field-name="field.name"
              />
            </b-form-group>
            <b-button
              v-if="showSubmit && editMode"
              type="button"
              variant="primary"
              block
              @click="send()"
            >
              <span v-if="idToEdit">
                {{ $t("label_administration_save") }}</span
              >
              <span v-if="!idToEdit">
                {{ $t("label_administration_create") }}</span
              >
              {{ tableName }}
            </b-button>
            <!--            <b-button v-if="idToEdit && showSubmit" type="button" variant="primary" @click="newE" block>
              New {{tableName}}
            </b-button>-->
          </b-form-group>
        </b-form>
        <b-button
          v-if="showEdit && !editMode"
          variant="primary"
          style="margin-top: 15px; float: right"
          @click="editMode = !editMode"
        >
          Editar
        </b-button>
      </b-col>
    </b-row>
    <template v-if="tableData.extraSections && showExtraSections">
      <b-row
        v-for="(extraSection, extraSectionIndex) in tableData.extraSections"
        :key="extraSectionIndex"
      >
        <b-col>
          <account-role-ruled-by
            v-if="extraSection === 'ruled-by'"
            :account-role-id="idToEdit"
          />
        </b-col>
      </b-row>
    </template>
    <b-row v-if="showMany">
      <b-col>
        <div
          v-for="(many, index) of tableData.ManyToManyRelationships"
          :key="index"
          style="margin-top: 50px; margin-bottom: 50px"
          horizontal
          breakpoint="lg"
          label-size="lg"
          label-class="break-label"
        >
          <h2>Seleccione {{ many.tableName }}</h2>
          <indica-checkbox-hierarchy
            :table-name="tableName"
            :current-id="idToEdit"
            :many-table-name="many.tableName"
            :name-field="many.nameField"
            :save-on-click="false"
          />
        </div>
      </b-col>
    </b-row>
    <b-modal
      id="modalInfo"
      v-model="showModal"
      modal-class="modalInfo"
      :title="$t('Guardado satisfactoriamente')"
    >
      <p>{{ $t("Guardado satisfactoriamente") }}</p>
      <div slot="modal-footer" class="w-100">
        <b-btn variant="primary" @click="showModal = false">
          {{ $t("label_selfAssessment_submitReview_modal_confirmation") }}
        </b-btn>
      </div>
    </b-modal>

    <b-modal
      id="modalInfo"
      v-model="showModalPasswordConfirmation"
      modal-class="modalInfo"
      :title="$t('Guardado satisfactoriamente')"
    >
      <p>{{ $t("Guardado satisfactoriamente") }}</p>
      <div slot="modal-footer" class="w-100">
        <b-btn variant="primary" @click="showModalPasswordConfirmation = false">
          {{ $t("label_selfAssessment_submitReview_modal_confirmation") }}
        </b-btn>
      </div>
    </b-modal>

    <b-modal
      id="modalInfo-password"
      v-model="showResetPasswordModal"
      modal-class="modalInfo"
      :title="$t('Reset Password')"
    >
      <p>{{ $t("Please enter the new password for the user ") }} <b> {{getEmail()}}</b></p>
      <b-input v-model="newPassword"></b-input>
      <div slot="modal-footer" class="w-100" align="right">
        <b-btn style="margin-right: 10px" @click="showResetPasswordModal = false">
          {{ $t("Cancel") }}
        </b-btn>
        <b-btn variant="primary" @click="resetPassword()">
          {{ $t("Set new password") }}
        </b-btn>
      </div>
    </b-modal>
  </b-container>
</template>
<script>
/* eslint-disable vue/no-mutating-props */
import { FieldType, validateField, validateFieldAsync } from "../commons";
import { GetTableDataByName } from "./tablesConfiguration";
import { axiosCall } from "../axiosCall";
import FormError from "../../components/template/_template-error";
import { mapGetters } from "vuex";
import IndicaCheckboxHierarchy from "./indica-checkbox-hierachy";
import AccountRoleRuledBy from "@/components/modules/administration/AccountRoleRuledBy";
import {getField} from "vuex-map-fields";

export default {
  name: "IndicaForm",
  components: { AccountRoleRuledBy, IndicaCheckboxHierarchy, FormError },
  data() {
    return {
      FieldType: FieldType,
      tableData: null,
      errors: {},
      showModal: false,
      showResetPasswordModal:false,
      showModalPasswordConfirmation:false,
      selectedEmail:'',
      newPassword:'',
    };
  },
  methods: {
    getEmail(){
      return this.tableData?.fields.find(f=>f.name==="username")?.value
    },
    getField,
    getValueFromList(value, options) {
      if (!value) {
        return value;
      }
      let option = options.find((option) => option.value === value);
      return option ? this.$t(option.text) : value;
    },
    getFieldsByCategory(fields, category) {
      return fields.filter((field) => field.fieldCategory === category);
    },
    goToList() {
      this.$router.push(`/configuration/${this.tableName}/list`);
    },
    idToEditChanged: async function () {
      if (this.idToEdit) {
        await axiosCall({
          url: `${this.tableData.endpoint}/${this.idToEdit}`,
          method: "get",
        }).then((data) => {
          this.clearForm();
          let responseData = data.data;
          if (this.tableData.endpoint === "Businesses") {
            responseData = responseData.business;
          }
          this.tableData.fields.map((field) => {
            if (typeof responseData[field.name] !== "undefined") {
              field.value = responseData[field.name];
            }
          });
        });
      }
    },
    newE() {
      this.$emit("refresh");
      this.clearForm();
    },
    clearForm() {
      this.tableData.fields.map((field) => {
        field.value = null;
      });
    },
    resetPassword: async function(){
      if(this.idToEdit){
        await axiosCall( {
          url: 'UserAccounts/reset-password-admin',
          method: "post",
          data: {userId:this.idToEdit,newPassword:this.newPassword},
        }).then(() => {
          this.newPassword = ''
          this.showResetPasswordModal = false
          this.showModalPasswordConfirmation = true
        });
      }
    },
    send: async function () {
      if (!this.saveToStore) {
        const dataToSend = {};
        this.tableData.fields.map((field) => {
          dataToSend[field.name] = field.value;
        });
        if(this.idToEdit) {
          delete dataToSend.password;
        }
        let apiCall = {
          url: this.tableData.customCreateEndpoint || this.tableData.endpoint,
          method: "post",
          data: dataToSend,
        };
        if (this.idToEdit) {
          apiCall = {
            url: `${this.tableData.endpoint}/${this.idToEdit}`,
            method: "patch",
            data: dataToSend,
          };
        }
        await axiosCall(apiCall).then((response) => {
          this.$emit("refresh", response.data);
          this.showModal = true;
          if (this.shouldClearForm) {
            this.clearForm();
          } else {
            this.editMode = false;
          }
        });
      } else {
        this.$emit("refresh");
      }
    },
    async checkValidations(field) {
      this.errors[field.name] = [];
      this.errors = validateField(
        field.name,
        field.value,
        field.validations,
        this.errors
      );
      this.errors = await validateFieldAsync(
        field.name,
        field.value,
        field.validations,
        this.errors
      );
      this.$emit("errors", this.errors);
      this.$forceUpdate();
    },
    async validForm() {
      for (let index = 0; index < this.tableData.fields.length; index++) {
        await this.checkValidations(this.tableData.fields[index]);
      }
      let valid = true;
      Object.keys(this.errors).map((error) => {
        if (this.errors[error] && this.errors[error].length) {
          valid = false;
        }
      });
      return valid;
    },
    getTableData() {
      if (this.tableName) {
        this.tableData = GetTableDataByName(this.tableName);
        this.clearForm();
        this.tableData.fields
          .filter((field) => field.type === FieldType.SELECT)
          .map(async (field) => {
            if (field.selectOptionsName) {
              field.selectOptions = this.getOptionListByName(
                field.selectOptionsName
              ).map((data) => {
                return {
                  value: data.name,
                  text: this.$t(data.name),
                };
              });
            }
            if (field.selectTablename) {
              let where = {};
              if (this.filterSelector && this.filterSelector.length) {
                const filter = this.filterSelector.find(
                  (filter) => filter.fieldName === field.name
                );
                if (filter) {
                  where = { where: { ...filter.filter } };
                }
              }
              await axiosCall({
                url: `${field.selectTablename}?filter=${JSON.stringify(where)}`,
                method: "get",
              }).then((response) => {
                field.selectOptions = response.data.map((data) => {
                  return {
                    value: data[field.selectId],
                    text: this.$t(data[field.selectName]),
                  };
                });
              });
            }
            field.selectOptions.sort((optionA, optionB) =>
              optionA.text.localeCompare(optionB.text)
            );
          });
        if (this.preFilledValues) {
          this.preFilledValues.map((preVal) => {
            this.tableData.fields
              .filter((field) => field.name === preVal.name)
              .map((field) => {
                field.value = preVal.value;
                field.disabled = true;
              });
          });
        }
      }
    },
    getStoreData() {
      if (this.saveToStore === true && this.storeName) {
        const _ = require("lodash");
        let storeInfo = _.cloneDeep(
          this.$store.getters.getStoreInfo(this.storeName)
        );
        if (storeInfo) {
          if (this.storeIndex !== -1) {
            storeInfo = storeInfo[this.storeIndex];
          }
        }
        if (storeInfo) {
          Object.keys(storeInfo).map((preVal) => {
            this.tableData.fields
              .filter((field) => field.name === preVal)
              .map((field) => {
                field.value = storeInfo[preVal];
              });
          });
        }
      }
    },
    saveOnKeyUp(name, value, isDate = false) {
      const payload = {};
      payload["data"] = {};
      payload["storeName"] = this.storeName;
      payload["storeIndex"] = this.storeIndex;
      payload["data"][name] = !isDate ? value : new Date(value).toISOString();
      const field = this.tableData.fields.find((field) => field.name === name);
      if (field && field.fieldRules) {
        field.fieldRules.map((fieldRule) => {
          switch (fieldRule.rule) {
            case "setSelectFieldText": {
              const selectorOptions = field.selectOptions.find(
                (options) => options.value === value
              );
              if (selectorOptions) {
                payload["data"][fieldRule.fieldName] = selectorOptions.text;
              }
              break;
            }
            case "setFieldValue":
              payload["data"][fieldRule.fieldName] = value;
              break;
          }
        });
      }
      this.$store.dispatch("setStoreInfo", payload);
      this.$emit("savedToStore");
    },
  },
  computed: {
    ...mapGetters({
      getOptionListByName: "getOptionListByName",
    }),
  },
  watch: {
    storeIndex: function () {
      this.getStoreData();
    },
    saveToStore: function () {
      this.getStoreData();
    },
    storeName: function () {},
    tableName: function () {
      this.getTableData();
    },
    preFilledValues: function () {
      this.getTableData();
    },
    idToEdit: async function () {
      await this.idToEditChanged();
    },
  },
  created: async function () {
    this.getTableData();
    this.getStoreData();
    await this.idToEditChanged();
  },
  props: {
    tableName: {
      type: String,
      default: null,
    },
    idToEdit: {
      type: String,
      default: null,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showReturn: {
      type: Boolean,
      default: true,
    },
    showMany: {
      type: Boolean,
      default: true,
    },
    preFilledValues: {
      type: Array,
      default: null,
    },
    saveToStore: {
      type: Boolean,
      default: false,
    },
    showSubmit: {
      type: Boolean,
      default: true,
    },
    labelPrefix: {
      type: String,
      default: "",
    },
    titleLabel: {
      type: String,
      default: "",
    },
    descriptionLabel: {
      type: String,
      default: "",
    },
    storeName: {
      type: String,
      default: null,
    },
    storeIndex: {
      type: Number,
      default: -1,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    groupByCategory: {
      type: Boolean,
      default: false,
    },
    shouldClearForm: {
      type: Boolean,
      default: true,
    },
    showExtraSections: {
      type: Boolean,
      default: true,
    },
    filterSelector: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss">
.formGeneric {
  label {
    word-break: break-word;
  }
  .input-error {
    border: 1px solid red;
  }
}
</style>
